import { createContext, useContext, ReactNode } from "react";
import { useActionColumns } from "./ActionsGrid/useActionColumns";
import { useGridColumns, GridColumnsType } from "src/components/Grid/hooks/columnsExtension/useGridColumns";
import type { UseGridColumnsOptions } from "src/components/Grid/hooks/columnsExtension/useGridColumns";
import { ActionGridData } from "./ActionsGrid/ActionsGrid";

type ActionsListContextInitialValues = {
    mrt_columns: GridColumnsType<ActionGridData>;
    gridKey: string;
};

const ActionsListContext = createContext<ActionsListContextInitialValues | null>(null);

type ActionsListContextProviderProps = {
    children: ReactNode;
    gridColumnsOptions?: UseGridColumnsOptions;
};

export const ActionsListContextProvider = (props: ActionsListContextProviderProps) => {
    const { children, gridColumnsOptions } = props;

    const gridKey = "actions-planning-grid";

    const { mrt_columns: actionColumns } = useActionColumns();
    const mrt_columns = useGridColumns(actionColumns, gridKey, gridColumnsOptions);

    const items: ActionsListContextInitialValues = {
        mrt_columns: { ...mrt_columns },
        gridKey: gridKey,
    };

    return <ActionsListContext.Provider value={items}>{children}</ActionsListContext.Provider>;
};

export const useActionsListContext = () => {
    const context = useContext(ActionsListContext);

    if (context) {
        return context;
    }

    throw new Error(`useActionsListContext must be used within an ActionsListContextProvider`);
};
